import { createStore } from 'redux';
import allReducer from './reducers';

const configureStore = () => {
  return createStore(allReducer);
};

export default configureStore;
